export default "__VITE_ASSET__CtEpBVGX__"